import { useMembers } from "../hooks/index";
const GetMembersPage = () => {
  const { data, isLoading, status } = useMembers();
  if (isLoading) return <div className="spinner"></div>;

  if (status === "failed")
    return (
      <h4 className="my-5 py-5  text-center getInvolvedline">
        No Data Available
      </h4>
    );
  const membersData = data?.members;

  if (membersData === undefined)
    return (
      <h4 className="my-5 py-5  text-center getInvolvedline">
        No Data Available
      </h4>
    );
  return (
    <div className="App container mt-5 w-75 position-relative">
      <h4 className="text-center getInvolvedline">Members</h4>
      <div className="row">
        {membersData?.map((person, index) => (
          <div key={index} className="col-md-6 mb-4">
            <div className="card shadow-sm p-3 d-flex flex-row align-items-center">
              <img
                src={`${
                  process.env.REACT_APP_BASE_IMG_URL + person.images[0].url
                }`}
                alt={person.name}
                className="rounded-circle me-3 object-fit-cover"
                width="80"
                height="80"
              />
              <div>
                <h5 className="fw-bold">{person.name}</h5>
                {person.designation && (
                  <p className="mb-1">{person.designation}</p>
                )}
                <p className="text-muted">{person.location}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default GetMembersPage;
